import React, { useEffect } from 'react';
import {
  oneOf,
  bool as boolType,
  number as numberType,
  array,
  object,
  oneOfType,
} from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { RecsFBTProductPodCarousel } from './RecsFBTProductPodCarousel';

export const RecsPropductPod = (props) => {
  const {
    brandTitleMaxLine,
    hideRating,
    hideTitle,
    hideATC,
    slidesPer,
    normalizedProducts,
    product
  } = props;
  const { storeId, storeZip: zipCode, membershipInformation } = useStore();
  // const zipCode = typeof window !== 'undefined' ? window.cookieUtils?.readBrowserCookie?.('DELIVERY_ZIP') : '';
  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined' && normalizedProducts) {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('RecsFBT.ready', { products: normalizedProducts });
    }
  }, []);

  return (
    <>
      <RecsFBTProductPodCarousel
        brandTitleMaxLine={brandTitleMaxLine}
        itemClass="fixed-item"
        storeId={storeId}
        zipCode={zipCode}
        itemId={product?.itemId}
        hideRating={hideRating}
        hideShopThisCollection
        hideShippingInfo
        hideATC={hideATC}
        membershipInformation={membershipInformation}
        hideTitle={hideTitle}
        loadingImageHeight={250}
        loadingLinesCount={10}
        data={normalizedProducts}
        slidesPer={slidesPer}
      />
    </>
  );
};

RecsPropductPod.propTypes = {
  brandTitleMaxLine: oneOf([2, 3, null]),
  hideRating: boolType,
  hideATC: boolType,
  hideTitle: boolType,
  slidesPer: numberType,
  normalizedProducts: oneOfType([array, object]),
  product: oneOfType([object, array])
};

RecsPropductPod.defaultProps = {
  brandTitleMaxLine: null,
  hideRating: false,
  hideATC: true,
  hideTitle: false,
  slidesPer: null,
  normalizedProducts: null,
  product: null
};
